import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

import { useQueryAnalyticsKpi } from '~/data/analytics';

import { i18n } from '~/utils';

import { withErrorBoundary } from '@vestigas/ui';

import { getKpiProps, useDateRange } from '../utils';

import { KPI } from './KPI';

/**
 * KpiDeliveryNotesSigned
 *
 * Displays the number of signed delivery notes for the selected date range.
 */
export const KpiDeliveryNotesSigned = withErrorBoundary(
  ({ className, style }: ComponentStyling) => {
    const { t } = useTranslation('analytics');

    const dateRange = useDateRange();

    const { data, isFetching } = useQueryAnalyticsKpi({
      dateRange,
      kpiName: 'signed_dlns',
    });

    const kpi = getKpiProps({
      iconMetaphor: 'deliveryNoteSigned',
      kpiColor: 'text-green-700',
      label: t(($) => $.usage.deliveryNotes.signed),
      previousValue: (data?.previousValue ?? 0) * 100,
      tooltip: t(($) => $.usage.deliveryNotes.signedTooltip),
      unit: '%',
      value: (data?.value ?? 0) * 100,
    });

    return (
      <KPI
        className={cn(
          'rounded-lg border border-green-300 bg-green-100 p-4',
          className,
        )}
        style={style}
        isLoading={isFetching}
        {...kpi}
      />
    );
  },
  i18n.t(($) => $.errorBoundary.fallbackMessage, {
    ns: 'analytics',
    section: i18n.t(($) => $.usage.deliveryNotes.signed, { ns: 'analytics' }),
  }),
);

KpiDeliveryNotesSigned.displayName = 'KpiDeliveryNotesSigned';
